// Base colos from sketch
export const black = '#000';
export const white = '#fff';
export const gray100 = '#F8F9FA';
export const gray150 = '#F6F7F8';
export const gray200 = '#E9ECEF';
export const gray300 = '#DEE2E6';
export const gray400 = '#CED4DA';
export const gray500 = '#ADB5BD';
export const gray600 = '#6C757D';
export const gray700 = '#495057';
export const gray800 = '#343A40';
export const gray900 = '#212529';

export const tableHoverBg = '#FFFFDD';

export const primary = '#0269BD';
export const primaryHover = '#0C5B9B';
export const primaryActive = '#134D7C';
export const primaryHoverDark = '#054173';
export const deepSkyBlue = '#00bfff';
export const lightSkyBlue = '#87cefa';

export const red = '#E60000';
export const redHover = '#BD0D0D';
export const redActive = '#971616';

export const green = '#8CBF54';
export const greenHover = '#7AA14F';
export const greenActive = '#698549';
export const palegreen = '#98fb98';

export const gold = '#FFD700';

export const orange = '#ffa500';

export const vieurekaOrange = '#FF6F00';
export const vieurekaBlue = '#394D5D';

// Other Colors
export const defaultDropShadow = 'rgba(0, 0, 0, 0.25)';
export const whiteOpacity10 = 'rgba(255, 255, 255, 0.1)';
export const separatorGray = '#CCC';
export const cpuMeterGray = '#DFDFDF';
export const resourceUsageBlue = '#6AA5E7';
export const resourceUsageGreen = '#81ED6A';
export const resourceUsageBorderGray = '#272727';
export const terminalBlack = 'rgba(0, 0, 0, 0.8)';
export const emailNotificationTableSubTdGray = 'F9F9F9';
export const stateUpdating = '#E3F5FE';
export const stateError = '#FCE9E9';
export const stateBadCondition = '#FCE9E9';
export const errorNotificationSchedulesBlue = '#CDE6FF';

// timeLapse機能
export const countColor = {
  plus20PercentColor: 'rgba(0, 200, 0, 0.6)',
  plus10PercentColor: 'rgba(0, 200, 0, 0.5)',
  plus5PercentColor: 'rgba(0, 200, 0, 0.4)',
  minus5PercentColor: 'rgba(255, 0, 0, 0.4)',
  minus10PercentColor: 'rgba(255, 0, 0, 0.5)',
  minus20PercentColor: 'rgba(255, 0, 0, 0.6)',
  firstRowColor: 'rgba(2, 105, 189, 0.6)',
  rowNomalColor: 'rgba(206, 212, 218, 0.6)',
};

export const transparent = 'transparent';
export const stayButtonHoverColor = '#ffc720';
export const stayAndPassButtonColor = 'rgb(163 255 61)';
export const stayAndPassButtonHoverColor = '#9dc96e';
export const countTextColor = 'rgb(10 105 183)';
export const ratioTextColor = 'rgb(10 105 183)';
